import { DataTypes } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";

export const dateOfNextPeriodicReview: FieldSchema = {
  grid: {
    displayed: false,
    order: 22,
    ignoredForSearch: true,
  },
  name: "dateOfNextPeriodicReview",
  data: {
    active: false,
    type: DataTypes.DATE,
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Periodic review for CSV systems",
    type: InputTypes.DATE,
    displayed: false,
    disabled: true,
  },
};
